module.exports = __webpack_public_path__ + "img/a_moluscos.b1dca07c.svg";